import PropTypes from "prop-types"

import AssetShape from "@shapes/AssetShape"
import AddressShape from "@shapes/AddressShape"


const PropertyShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  photos: PropTypes.arrayOf(AssetShape),
  status: PropTypes.string,
  address: AddressShape.isRequired,
  investmentDate: PropTypes.string,
  equityDeployedAmount: PropTypes.number,
})

export default PropertyShape
